import { createApp } from 'vue';
import App from './App.vue';
// import './../node_modules/bulma/css/bulma.css';
import './assets/bulma-custom.scss';
import './styleLMC.css';

import { setScreen, initDeviceListener } from './code/utilita';

createApp(App).mount('#app');
setScreen();
initDeviceListener();

